import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import Pagination from "../../Pagination";
import Loader from "../../../img/Document scan.gif"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import TableProperties from "./TableProperties";
import UseToggle from "../../../Hooks/UseToggle";

const LocalDatasetManagement = ({ tableRef, onMouseDown, ids }) => {
  const [loader, setLoader] = useState(false);
  const [columnList, setColumnList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [tableColumns, setTableColumns] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (Number(pageNumber) - 1) * Number(itemsPerPage);
  const endIndex = startIndex + Number(itemsPerPage);
  let result = dataList?.slice(startIndex, endIndex) || [];
  let totalPage = Math.ceil(dataList?.length / itemsPerPage);

  const { toggle, setToggle } =
    UseToggle();

  const readSystemFileAsJSON = async (fullFilePath, oldExtension) => {
    setLoader(true)
    let userData = {
      filePath: `${fullFilePath}${oldExtension}`
    }
    let data = await editorProjectServices.readSystemFileAsJSON(userData);

    setColumnList(data?.data?.column || []);
    setDataList(data?.data?.row);
    setLoader(false)
  };

  useEffect(() => {
    if (ids?.fullFilePath && ids?.oldExtension) {
      readSystemFileAsJSON(ids?.fullFilePath, ids?.oldExtension);
    }
  }, [ids?.fullFilePath, ids?.oldExtension]);

  const downloadCSV = () => {
    if (!columnList || !dataList) return;
    const headers = columnList?.map((col) =>
      col.name
    );
    const rows = dataList?.map((row) =>
      columnList.map((col) => row?.[col?.name])
    );
    const csvArray = [headers, ...rows];
    const csvContent = csvArray
      .map((row) =>
        row
          .map((cell) =>
            typeof cell === "string" && cell.includes(",")
              ? `"${cell}"`
              : cell
          )
          .join(",")
      )
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${ids?.name}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadExcel = () => {
    if (!columnList || !result) return;
    const headers = columnList?.map((col) =>
      col.name
    );
    const rows = dataList?.map((row) =>
      columnList?.map((col) => row?.[col?.name])
    );
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `${ids?.name}.xlsx`);
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div></div>
        <div className="hstack gap-2">
          <button onClick={setToggle} className={`updateProfile`}>Table Properties</button>
          {ids?.lockStatus === "locked" &&
            <>
              <button onClick={downloadCSV} className={`updateProfile`}>CSV Download</button>
              <button onClick={downloadExcel} className={`updateProfile`}>Excel Download</button>
            </>
          }
        </div>
      </div>
      {loader ? (
        <div className="hstack justify-content-center"
          style={{ height: "calc(100vh - 181px)" }}>
          <img src={Loader} alt="Page Loader" />
        </div>
      ) : !ids?.uniqueId ? (
        <div className="hstack justify-content-center fw-bold text-muted"
          style={{ height: "calc(100vh - 181px)" }}>
          Not any field!
        </div>
      ) : dataList?.length === 0 ? (
        <NoDataFoundTable MSG={"Data Not Found!"} />
      ) :
        <>
          <div className="overflow-auto">
            <Table ref={tableRef} className="m-0 custom-table tableLibrary" hover striped>
              <thead className="position-sticky top-0">
                <tr>
                  {columnList?.map((col, index) =>
                    tableColumns[col?.name] ? null : (
                      <th
                        key={index}
                        style={{ cursor: "pointer" }}
                        onMouseDown={(e) => onMouseDown(e, index + 1)}
                      >
                        {col.name}
                      </th>
                    )
                  )}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {result?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columnList?.map((col, colIndex) =>
                      tableColumns[col?.name] ? null : (
                        <td key={colIndex}>{row?.[col.name]}</td>
                      )
                    )}
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="position-sticky bottom-0 start-0">
            <Pagination
              totalPage={totalPage}
              pageNumber={pageNumber}
              itemsPerPage={itemsPerPage}
              totalItems={dataList?.length}
              setPageNumber={setPageNumber}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </>
      }
      <TableProperties
        Show={!toggle}
        Hide={setToggle}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Table Properties"}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        columnList={columnList}
      />
    </>
  );
};

export default LocalDatasetManagement;
